<app-breadcrumb [title]="title + ' Datos facturación'" [breadcrumb]="title + ' Datos facturación'"></app-breadcrumb>
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">
            <form [formGroup]="facturacionForm" autocomplete="off">
                <div class="checkout-page">
                    <div class="checkout-form d-flex justify-content-center">
                        <div class="col-md-10">
                            <div class="row">
                                <!-- <div class="col-12 mb-3">
                                    <label for="rfc">Referencia de información:</label>
                                    <input  type="text" (input)="soloLetrasNumerosEspacios($event)" class="form-control text-uppercase"  formControlName="rfc" id="rfc" required="" maxlength="12" placeholder="Facturación Número 1">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                        Campo requerido
                                    </span>
                                </div> -->
                                <div class="col-md-6 mb-3">
                                    <label for="rfc">Clave del Registro Federal de Contribuyentes (RFC)</label>
                                    <input  type="text" (input)="soloLetrasNumerosExt($event)" class="form-control text-uppercase"  formControlName="rfc" id="rfc" required="" maxlength="13" placeholder="Ingresa el RFC">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                        Campo requerido
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').errors?.pattern)">
                                        El campo debe contener letras y números
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="regimenFiscal">Tipo persona</label>
                                    <select formControlName="tipoPersona" class="form-control" id="tipo"  (change)="changeTipoPersona()" required>
                                            <option value="fisica">
                                                Física
                                            </option>
                                            <option value="moral">
                                                Moral
                                            </option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('tipoPersona').touched) && facturacionForm.get('tipoPersona').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3" *ngIf="this.tipoPersona === 'moral'">
                                    <label for="nombre"> Denominación o razón social</label>
                                    <input type="text" formControlName="razonSocial" class="form-control" id="razonSocial" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('razonSocial').touched) && facturacionForm.get('razonSocial').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3" *ngIf="this.tipoPersona === 'fisica'">
                                    <label for="nombre"> Nombre</label>
                                    <input type="text" formControlName="nombre" class="form-control" id="nombre" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('nombre').touched) && facturacionForm.get('nombre').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3" *ngIf="this.tipoPersona === 'fisica'">
                                    <label for="apellidoPaterno"> Apellido paterno</label>
                                    <input type="text" formControlName="apellidoPaterno" class="form-control" id="apellidoPaterno" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('apellidoPaterno').touched) && facturacionForm.get('apellidoPaterno').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3" *ngIf="this.tipoPersona === 'fisica'">
                                    <label for="apellidoMaterno"> Apellido materno</label>
                                    <input type="text" formControlName="apellidoMaterno" class="form-control" id="apellidoMaterno" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('apellidoMaterno').touched) && facturacionForm.get('apellidoMaterno').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="domicilioFiscal">Código Postal del domicilio fiscal</label>
                                    <input type="text" formControlName="cp" class="form-control" id="domicilioFiscal" required (input)="soloNumerosDomFisc($event)" maxlength="5">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('cp').touched) && facturacionForm.get('cp').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="domicilioFiscal">Correo</label>
                                    <input type="text" formControlName="correo" class="form-control" id="correo">
                                    <span class="text-danger"
                                      *ngIf="facturacionForm.get('correo')?.touched && facturacionForm.get('correo')?.errors?.required">
                                      Campo requerido
                                    </span>
                                    <span class="text-danger"
                                      *ngIf="facturacionForm.get('correo')?.touched && facturacionForm.get('correo')?.errors?.pattern">
                                      Correo inválido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="domicilioFiscal">Teléfono</label>
                                    <input type="text" formControlName="telefono" class="form-control" id="telefono" required (input)="soloNumerosTelf($event)" maxlength="10">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('telefono').touched) && facturacionForm.get('telefono').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="regimenFiscal">Régimen Fiscal</label>
                                    <select formControlName="regimenFiscal" class="form-control" id="usoCfdi"  (change)="changeRf()" required [compareWith]="compareRf">
                                        <option
                                        style="text-overflow: ellipsis !important"
                                         value="" selected [disabled]="true">Seleccione</option>
                                            <option *ngFor="let rf of listaRegimenFiscal; index as i" [ngValue]="rf" >
                                                {{rf.tipoPersonaDescripcion}} - {{rf.valor}} - {{rf.descripcion}}
                                            </option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label id="usoCfdi">Uso CFDI</label>
                                    <select formControlName="usoCfdi" class="form-control" id="usoCfdi"  (change)="changeCdfi()" required>
                                        <option
                                        style="text-overflow: ellipsis !important"
                                         value="" selected [disabled]="true">Seleccione</option>
                                            <option *ngFor="let cfdi of listaCfdi; index as i" [ngValue]="cfdi" >
                                                {{cfdi.usoCFDI}} - {{cfdi.descripcion}}
                                            </option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                            </div>
                            <div class=" d-flex gap-3 justify-content-end">
                                <button class="btn btn-solid mt-2 " (click)="guardar()">Guardar</button>
                                <button class="btn btn-solid mt-2 " (click)="volver()">Volver</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>